const Select = Object.freeze({
  USCODE: 'US',
  SELECTCOUNTRY: 'Select Country',
  DEFAULT: 'default',
  SELECTSTATES: 'Select State',
});

export default Select;



// WEBPACK FOOTER //
// ./src/enum/Select.enum.jsx